import { Component } from '@angular/core';
import { DivisionalPromotionFilterType } from '@app/seller-showcase/models/seller-showcase.model';
import { IonNav, ModalController } from '@ionic/angular';
import { PlatformService } from '@panamax/app-state';
import { SellerShowcaseFiltersBaseComponent } from '../seller-showcase-filters-base.component';
import { SellerShowcaseFiltersInputMobileComponent } from './seller-showcase-filters-input-mobile/seller-showcase-filters-input-mobile.component';

@Component({
  selector: 'app-seller-showcase-filters-mobile',
  templateUrl: './seller-showcase-filters-mobile.component.html',
  styleUrls: ['./seller-showcase-filters-mobile.component.scss'],
})
export class SellerShowcaseFiltersMobileComponent extends SellerShowcaseFiltersBaseComponent {
  constructor(
    readonly platformService: PlatformService,
    private nav: IonNav,
    modalController: ModalController,
  ) {
    super(platformService, modalController);
  }

  setFilter(filterType: DivisionalPromotionFilterType) {
    this.selectedFilter = filterType;
    this.nav.push(SellerShowcaseFiltersInputMobileComponent, {
      selectedFilter: this.selectedFilter,
      brandsNames: this.brandsNames,
      selectedBrand: this.selectedBrand,
      promoTypes: this.promoTypes,
      selectedPromoType: this.selectedPromoType,
      exclusiveBrandValues: this.exclusiveBrandValues,
      selectedExclusiveBrand: this.selectedExclusiveBrand,
      productClasses: this.productClasses,
      selectedProductClass: this.selectedProductClass,
      callBack: this.callbackSetFilter.bind(this),
    });
  }

  callbackSetFilter(selectedValue: string) {
    if (selectedValue?.length) {
      switch (this.selectedFilter) {
        case DivisionalPromotionFilterType.brand:
          this.selectedBrand = selectedValue;
          break;
        case DivisionalPromotionFilterType.promoType:
          this.selectedPromoType = selectedValue;
          break;
        case DivisionalPromotionFilterType.exclusiveBrand:
          this.selectedExclusiveBrand = selectedValue;
          break;
        case DivisionalPromotionFilterType.productClass:
          this.selectedProductClass = selectedValue;
          break;
      }

      super.selectValue({ detail: { value: selectedValue } });
    }
  }
}
